import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";

import { Header } from "../../components/Header";
import {
  CONTINUE_BUTTON,
  INVALID_EMAIL_ADDRESS,
  INVALID_PHONE_NUMBER,
  PLEASE_PROVIDE_ADDRESS,
  PLEASE_PROVIDE_CITY,
  PLEASE_PROVIDE_COUNTRY,
  PLEASE_PROVIDE_EMAIL,
  PLEASE_PROVIDE_LAST_NAME,
  PLEASE_PROVIDE_MOBILE_PHONE_NUMBER,
  PLEASE_PROVIDE_POSTAL_CODE,
  POSTAL_CODE_MIN_LENGTH,
  REGISTRATION_ACCEPT,
  REGISTRATION_ADDRESS,
  REGISTRATION_CITY,
  REGISTRATION_COUNTRY,
  REGISTRATION_DATA_PRIVACY,
  REGISTRATION_DOB,
  REGISTRATION_EMAIL,
  REGISTRATION_FIRST_NAME,
  REGISTRATION_LAST_NAME,
  REGISTRATION_MOBILE_PHONE,
  REGISTRATION_POSTAL_CODE,
  REGISTRATION_SUPERVISOR_TITLE,
  VALIDATION_18_YEARS_OLD,
} from "../../constants/translationKeys";
import translationsStore from "../../stores/TranslationsStore";
import "./PersonRegistration.scss";
import supervisorStore from "../../stores/SupervisorStore";
import { getPublicKeyPem } from "../../utils/localStorage";
import { ErrorMessage } from "src/components/ErrorMessage/ErrorMessage";
import { DATA_PRIVACY } from "../../constants/routes";

const emailRegex =
  // eslint-disable-next-line no-control-regex
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

const PersonRegistratinPage = () => {
  const [dob, setDob] = useState<Date | null>(null);
  const [arePoliciesConfirmed, setArePoliciesConfirmed] = useState(false);
  const { translations } = translationsStore;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const alert = useAlert();

  useEffect(() => {
    if (supervisorStore.dobError) {
      alert.show(supervisorStore.dobError);
    }
  }, [alert]);

  // On form submit send data to store
  const onSubmit = (data: any) => {
    supervisorStore.isLoading = true;
    data.dob = moment(dob).format("yyyy-MM-DD");
    const yearsOld = moment().diff(data.dob, "years");
    if (yearsOld < 18) {
      supervisorStore.dobError = translations[VALIDATION_18_YEARS_OLD];
      supervisorStore.isLoading = false;
      return;
    }
    data.publicKey = getPublicKeyPem();

    supervisorStore.saveData(data);
  };

  return (
    <div>
      <Header />
      <div className="page-container">
        <h2>{translations[REGISTRATION_SUPERVISOR_TITLE]}</h2>

        <form onSubmit={handleSubmit(onSubmit)} className="form">
          <div className="field-wrap">
            <label htmlFor="last-name">
              {translations[REGISTRATION_LAST_NAME]}
            </label>
            <input
              id="last-name"
              {...register("lastName", {
                required:
                  translations[PLEASE_PROVIDE_LAST_NAME] ||
                  "Please provide last name",
              })}
              placeholder={translations[REGISTRATION_LAST_NAME]}
              className="input-field"
              type="text"
              defaultValue=""
            />
          </div>
          <ErrorMessage errors={errors} name="lastName" />

          <div className="field-wrap">
            <label htmlFor="first-name">
              {translations[REGISTRATION_FIRST_NAME]}
            </label>
            <input
              id="first-name"
              {...register("firstName", {
                required:
                  translations[PLEASE_PROVIDE_LAST_NAME] ||
                  "Please provide first name",
              })}
              placeholder={translations[REGISTRATION_FIRST_NAME]}
              className="input-field"
              type="text"
              defaultValue=""
            />
          </div>
          <ErrorMessage errors={errors} name="firstName" />
          <div className="field-wrap">
            <label htmlFor="dob">{translations[REGISTRATION_DOB]}</label>
            <input
              autoComplete="off"
              id="dob"
              placeholder={"DD.MM.YYYY"}
              className="input-field"
              max={new Date().toISOString().split("T")[0]}
              type="date"
              value={dob ? moment(dob).format("yyyy-MM-DD") : ""}
              onChange={(e) => {
                if (e.target.value) {
                  // @ts-ignore
                  setDob(e.target.value);
                }
              }}
            />
          </div>
          {/* <DatePicker
            customInput={
              <div className="field-wrap">
                <label htmlFor="dob">{translations[REGISTRATION_DOB]}</label>
                <input
                  autoComplete="off"
                  id="dob"
                  placeholder={"DD.MM.YYYY"}
                  className="input-field"
                  type="text"
                  value={dob ? moment(dob).format("DD.MM.YYYY") : ""}
                  onChange={() => {}}
                />
              </div>
            }
            placeholderText={translations[REGISTRATION_DOB]}
            onChange={(date) => {
              if (date) {
                // @ts-ignore
                setDob(date);
              }
            }}
            showYearDropdown
            showMonthDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={150}
            maxDate={new Date()}
            dropdownMode="select"
          /> */}
          {supervisorStore.dobError && (
            <span className="errorMessage">{supervisorStore.dobError}</span>
          )}

          <div className="field-wrap">
            <label htmlFor="mobile-phone">
              {translations[REGISTRATION_MOBILE_PHONE]}
            </label>
            <input
              id="mobile-phone"
              {...register("mobilePhone", {
                required:
                  translations[PLEASE_PROVIDE_MOBILE_PHONE_NUMBER] ||
                  "Please provide mobile phone number",
                pattern: {
                  value: /^(\+\d{1,3}[- ]?)?\d{10}$/,
                  message:
                    translations[INVALID_PHONE_NUMBER] ||
                    "Invalid mobile phone number",
                },
              })}
              placeholder={translations[REGISTRATION_MOBILE_PHONE]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="mobilePhone" />
          </div>

          <div className="field-wrap">
            <label htmlFor="email">{translations[REGISTRATION_EMAIL]}</label>
            <input
              id="email"
              {...register("email", {
                required:
                  translations[PLEASE_PROVIDE_EMAIL] ||
                  "Please provide an email",
                pattern: {
                  value: emailRegex,
                  message:
                    translations[INVALID_EMAIL_ADDRESS] ||
                    "Invalid email address",
                },
              })}
              placeholder={translations[REGISTRATION_EMAIL]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="email" />
          </div>

          <div className="field-wrap">
            <label htmlFor="address">
              {translations[REGISTRATION_ADDRESS]}
            </label>

            <input
              id="address"
              {...register("address", {
                required:
                  translations[PLEASE_PROVIDE_ADDRESS] ||
                  "Please provide an address",
              })}
              placeholder={translations[REGISTRATION_ADDRESS]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="address" />
          </div>

          <div className="field-wrap">
            <label htmlFor="postal-code">
              {translations[REGISTRATION_POSTAL_CODE]}
            </label>

            <input
              id="postal-code"
              {...register("postalCode", {
                required:
                  translations[PLEASE_PROVIDE_POSTAL_CODE] ||
                  "Please provide a postal code",
                minLength: {
                  value: 4,
                  message:
                    translations[POSTAL_CODE_MIN_LENGTH] ||
                    "Postal code should be at least 4 characters long",
                },
              })}
              placeholder="XXXX"
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="postalCode" />
          </div>

          <div className="field-wrap">
            <label htmlFor="city">{translations[REGISTRATION_CITY]}</label>

            <input
              id="city"
              {...register("city", {
                required:
                  translations[PLEASE_PROVIDE_CITY] || "Please provide a city",
              })}
              placeholder={translations[REGISTRATION_CITY]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="city" />
          </div>

          <div className="field-wrap">
            <label htmlFor="country">
              {translations[REGISTRATION_COUNTRY]}
            </label>
            <select
              id="country"
              className="input-field select"
              {...register("country", {
                required:
                  translations[PLEASE_PROVIDE_COUNTRY] ||
                  "Please provide a country",
              })}
            >
              <option value="switzerland">Switzerland</option>
              <option value="germany">Germany</option>
            </select>
            <ErrorMessage errors={errors} name="country" />
          </div>

          <div className="flex">
            <div className="checkboxRow">
              <input
                name="istructions"
                type="checkbox"
                defaultChecked={arePoliciesConfirmed}
                onChange={(e) => {
                  setArePoliciesConfirmed(e.target.checked);
                }}
              />

              <p
              // onClick={() => {
              //   setArePoliciesConfirmed(!arePoliciesConfirmed);
              // }}
              >
                {translations[REGISTRATION_ACCEPT] || "Accept"}{" "}
                <Link to={DATA_PRIVACY}>
                  {translations[REGISTRATION_DATA_PRIVACY] || "Data Privacy"}
                </Link>
              </p>
            </div>
          </div>
          <button
            className={`button filled-button ${
              supervisorStore.isLoading || !arePoliciesConfirmed
                ? "button--state-disable"
                : ""
            } onboarding-continue-button business-registration-form-submit-button`}
          >
            {translations[CONTINUE_BUTTON]}
          </button>
        </form>
      </div>
    </div>
  );
};

export default observer(PersonRegistratinPage);
